module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-backForm', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.full_screenFlag),
      expression: "full_screenFlag",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "name": 'back-taskExam',
      "align": true
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backSet
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title",
    class: {
      more: _vm.money_flag
    }
  }, [_vm._v("任务金额")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('div', {
    staticClass: "switch-line"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.money_flag),
      callback: function($$v) {
        _vm.money_flag = $$v
      },
      expression: "money_flag"
    }
  }), _vm._v(" "), _c('div', [_vm._v("启用审核限制")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.money_flag),
      expression: "money_flag"
    }],
    staticClass: "add"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.money_limit),
      expression: "money_limit"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "number"
    },
    model: {
      value: (_vm.money_limit),
      callback: function($$v) {
        _vm.money_limit = $$v
      },
      expression: "money_limit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("当任务奖金大于等于设置金额时，即需要审核")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "back-item",
    style: ({
      height: _vm.change_height
    })
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("任务类型")]), _vm._v(" "), _c('div', {
    ref: "check",
    staticClass: "back-wrap check"
  }, [_c('div', {
    staticClass: "switch-line"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.check_flag),
      callback: function($$v) {
        _vm.check_flag = $$v
      },
      expression: "check_flag"
    }
  }), _vm._v(" "), _c('div', [_vm._v("启用审核限制")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_flag),
      expression: "check_flag"
    }],
    ref: "task-list",
    staticClass: "add"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.taskType_limit),
      callback: function($$v) {
        _vm.taskType_limit = $$v
      },
      expression: "taskType_limit"
    }
  }, _vm._l((_vm.taskTpl), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id + ''
      }
    }, [_vm._v(_vm._s(item.tpl_name))])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.taskType_limit_str),
      expression: "taskType_limit_str"
    }],
    ref: "checkInput",
    attrs: {
      "rule": _vm.check_flag ? 'checkgroup' : ''
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-164c80f0!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/task-exam.vue
// module id = 696
// module chunks = 1